<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<div class="sidebar" [ngClass]="{'sidebar-open': sidebarOpen }" (click)="emitCloseSidebar()">
  <div class="sidebar-header">
    Template
  </div>
  <div class="container-fluid sidebar-body">
    <div class="row visible-xs">
      <div class="col-xs-12">
        <span>Logout</span>
        <span class="pull-right">
					<i class="fa fa-angle-right"></i>
				</span>
      </div>
    </div>
  </div>
  <div class="sidebar-footer container-fluid">
    <div class="row">
      <div class="col-xs-12">
        GMID
      </div>
      <div class="col-xs-12">
        {{currentDate | date:"MM/dd/yyyy"}}
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        GENERAL MOTORS
      </div>
      <div class="col-xs-12">
        PGA v1.0.0
      </div>
    </div>
  </div>
</div>
